/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */

export type TransactionCodeNameEnum = typeof TransactionCodeNameEnum[keyof typeof TransactionCodeNameEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionCodeNameEnum = {
  Commitment_Made: 'Commitment Made',
  'Capital_Contribution_-_Bridge_Equity': 'Capital Contribution - Bridge Equity',
  'Capital_Contribution_-_Capitalizable_Expenses': 'Capital Contribution - Capitalizable Expenses',
  'Capital_Contribution_-_Investment': 'Capital Contribution - Investment',
  'Capital_Contribution_-_Management_Fee_(Affects_Unfunded)': 'Capital Contribution - Management Fee (Affects Unfunded)',
  'Capital_Contribution_-_Management_Fee_(Does_not_Affect_Unfunded)': 'Capital Contribution - Management Fee (Does not Affect Unfunded)',
  'Capital_Contribution_-_Management_Fee_Break': 'Capital Contribution - Management Fee Break',
  'Capital_Contribution_-_Management_Fee_Offset': 'Capital Contribution - Management Fee Offset',
  'Capital_Contribution_-_Management_Fee_Interest': 'Capital Contribution - Management Fee Interest',
  'Capital_Contribution_-_Management_Fee_-_Custom_Amount_Pro_Rata': 'Capital Contribution - Management Fee - Custom Amount Pro Rata',
  'Capital_Contribution_-_Partnership_Expenses': 'Capital Contribution - Partnership Expenses',
  'Capital_Contribution_-_Partnership_Expenses_-_Account,_Admin,_&_IT': 'Capital Contribution - Partnership Expenses - Account, Admin, & IT',
  'Capital_Contribution_-_Partnership_Expenses_-_Audit_&_Tax_Prep': 'Capital Contribution - Partnership Expenses - Audit & Tax Prep',
  'Capital_Contribution_-_Partnership_Expenses_-_Bank_Fees': 'Capital Contribution - Partnership Expenses - Bank Fees',
  'Capital_Contribution_-_Partnership_Expenses_-_Custody_Fees': 'Capital Contribution - Partnership Expenses - Custody Fees',
  'Capital_Contribution_-_Partnership_Expenses_-_Due_Diligence': 'Capital Contribution - Partnership Expenses - Due Diligence',
  'Capital_Contribution_-_Partnership_Expenses_-_Legal': 'Capital Contribution - Partnership Expenses - Legal',
  'Capital_Contribution_-_Partnership_Expenses_-_Organization_Costs': 'Capital Contribution - Partnership Expenses - Organization Costs',
  'Capital_Contribution_-_Excess_Organization_Costs': 'Capital Contribution - Excess Organization Costs',
  'Capital_Contribution_-_Partnership_Expenses_-_Other_Travel_&_Entertainment': 'Capital Contribution - Partnership Expenses - Other Travel & Entertainment',
  'Capital_Contribution_-_Partnership_Expenses_-_Other': 'Capital Contribution - Partnership Expenses - Other',
  'Capital_Contribution_-_Subsequent_Close_Interest': 'Capital Contribution - Subsequent Close Interest',
  'Capital_Contribution_-_General_/_Reserve': 'Capital Contribution - General / Reserve',
  'Capital_Contribution_-_Placement_Fees': 'Capital Contribution - Placement Fees',
  'Capital_Contribution_-_Waiver': 'Capital Contribution - Waiver',
  'Capital_Contribution_-_Federal_Taxes': 'Capital Contribution - Federal Taxes',
  'Capital_Contribution_-_State_Taxes': 'Capital Contribution - State Taxes',
  'Capital_Contribution_-_Carry_Clawback': 'Capital Contribution - Carry Clawback',
  'Capital_Contribution_-_Prefund_Expenses': 'Capital Contribution - Prefund Expenses',
  'Capital_Contribution_-_Prefund_Investments': 'Capital Contribution - Prefund Investments',
  'Capital_Contribution_-_Working_Capital': 'Capital Contribution - Working Capital',
  'Capital_Contribution_-_Return_of_Unused_Contributions': 'Capital Contribution - Return of Unused Contributions',
  'Fund_Distribution_-_Bridge_Equity': 'Fund Distribution - Bridge Equity',
  'Fund_Distribution_-_Investment_Operating_Income_-_Cash': 'Fund Distribution - Investment Operating Income - Cash',
  'Fund_Distribution_-_Investment_Operating_Income_(Recallable)_-_Cash': 'Fund Distribution - Investment Operating Income (Recallable) - Cash',
  'Fund_Distribution_-_Investment_Operating_Income_-_Stock': 'Fund Distribution - Investment Operating Income - Stock',
  'Fund_Distribution_-_Investment_Operating_Income_(Recallable)_-_Stock': 'Fund Distribution - Investment Operating Income (Recallable) - Stock',
  'Fund_Distribution_-_Realized_Gain_-_Cash': 'Fund Distribution - Realized Gain - Cash',
  'Fund_Distribution_-_Realized_Gain_(Recallable)_-_Cash': 'Fund Distribution - Realized Gain (Recallable) - Cash',
  'Fund_Distribution_-_Realized_Gain_-_Stock': 'Fund Distribution - Realized Gain - Stock',
  'Fund_Distribution_-_Realized_Gain_(Recallable)_-_Stock': 'Fund Distribution - Realized Gain (Recallable) - Stock',
  'Fund_Distribution_-_Realized_Loss_-_Cash': 'Fund Distribution - Realized Loss - Cash',
  'Fund_Distribution_-_Realized_Loss_(Recallable)_-_Cash': 'Fund Distribution - Realized Loss (Recallable) - Cash',
  'Fund_Distribution_-_Realized_Loss_-_Stock': 'Fund Distribution - Realized Loss - Stock',
  'Fund_Distribution_-_Realized_Loss_(Recallable)_-_Stock': 'Fund Distribution - Realized Loss (Recallable) - Stock',
  'Fund_Distribution_-_Return_of_Capital_-_Cash': 'Fund Distribution - Return of Capital - Cash',
  'Fund_Distribution_-_Return_of_Capital_(Recallable)_-_Cash': 'Fund Distribution - Return of Capital (Recallable) - Cash',
  'Fund_Distribution_-_Return_of_Capital_-_Stock': 'Fund Distribution - Return of Capital - Stock',
  'Fund_Distribution_-_Return_of_Capital_(Recallable)_-_Stock': 'Fund Distribution - Return of Capital (Recallable) - Stock',
  'Fund_Distribution_-_Return_of_Capital_-_Management_Fees': 'Fund Distribution - Return of Capital - Management Fees',
  'Fund_Distribution_-_Return_of_Capital_-_Management_Fees_(Recallable)': 'Fund Distribution - Return of Capital - Management Fees (Recallable)',
  'Fund_Distribution_-_Return_of_Capital_-_Expenses': 'Fund Distribution - Return of Capital - Expenses',
  'Fund_Distribution_-_Return_of_Capital_-_Expenses_(Recallable)': 'Fund Distribution - Return of Capital - Expenses (Recallable)',
  'Fund_Distribution_-_Subsequent_Close_Interest': 'Fund Distribution - Subsequent Close Interest',
  'Fund_Distribution_-_LP_Carry': 'Fund Distribution - LP Carry',
  'Fund_Distribution_-_LP_Carry_Clawback': 'Fund Distribution - LP Carry Clawback',
  'Fund_Distribution_-_GP_Carry': 'Fund Distribution - GP Carry',
  'Fund_Distribution_-_GP_Carry_Clawback': 'Fund Distribution - GP Carry Clawback',
  'Fund_Distribution_-_GP_Carry_-_Hypothetical': 'Fund Distribution - GP Carry - Hypothetical',
  'Fund_Distribution_-_LP_Tax_Withholding': 'Fund Distribution - LP Tax Withholding',
  'Fund_Distribution_-_LP_Bank_Fee_Withholding': 'Fund Distribution - LP Bank Fee Withholding',
  GP_Tax_Distribution: 'GP Tax Distribution',
  'GP_Tax_Distribution_-_Repaid': 'GP Tax Distribution - Repaid',
  'Fund_Distribution_-_Preferred_Return': 'Fund Distribution - Preferred Return',
  'Fund_Distribution_-_GP_Carry_Deferral': 'Fund Distribution - GP Carry Deferral',
  'Fund_Distribution_-_Working_Capital': 'Fund Distribution - Working Capital',
  'Fund_Distribution_-_Temporary_Investment_Income': 'Fund Distribution - Temporary Investment Income',
  'Fund_Distribution_-_Return_of_Excess_-_Investment': 'Fund Distribution - Return of Excess - Investment',
  'Fund_Distribution_-_Return_of_Excess_-_Management_Fees': 'Fund Distribution - Return of Excess - Management Fees',
  'Fund_Distribution_-_Return_of_Excess_-_Partnership_Expenses': 'Fund Distribution - Return of Excess - Partnership Expenses',
  'Fund_Distribution_-_Return_of_Excess_-_Other': 'Fund Distribution - Return of Excess - Other',
  'Fund_Distribution_-_Return_of_Excess_-_Investment_-_Recallable': 'Fund Distribution - Return of Excess - Investment - Recallable',
  'Fund_Distribution_-_Return_of_Excess_-_Management_Fees_-_Recallable': 'Fund Distribution - Return of Excess - Management Fees - Recallable',
  'Fund_Distribution_-_Return_of_Excess_-_Partnership_Expenses_-_Recallable': 'Fund Distribution - Return of Excess - Partnership Expenses - Recallable',
  'Fund_Distribution_-_Return_of_Excess_-_Other_-_Recallable': 'Fund Distribution - Return of Excess - Other - Recallable',
  'Fund_Distribution_-_Return_of_Unused_Contributions_-_Recallable': 'Fund Distribution - Return of Unused Contributions - Recallable',
  'Fund_Distribution_-_Operating_Income_(Adj)': 'Fund Distribution - Operating Income (Adj)',
  Capital_Transfer_In: 'Capital Transfer In',
  Capital_Transfer_Out: 'Capital Transfer Out',
  'Capital_Contribution_-_Bridge_Financing': 'Capital Contribution - Bridge Financing',
  'Fund_Distribution_-_Return_of_Bridge_Financing': 'Fund Distribution - Return of Bridge Financing',
  'Fund_Distribution_-_Excess_Organization_Costs': 'Fund Distribution - Excess Organization Costs',
  'Fund_Distribution_-_Placement_Fees': 'Fund Distribution - Placement Fees',
  'Investment_-_Purchase': 'Investment - Purchase',
  'Investment_-_Purchase_-_Add_On': 'Investment - Purchase - Add On',
  'Investment_-_Pass-Through': 'Investment - Pass-Through',
  'Investment_-_Sale': 'Investment - Sale',
  'Investment_-_Dividend_Paid': 'Investment - Dividend Paid',
  'Investment_Distribution_-_ROC': 'Investment Distribution - ROC',
  'Investment_Distribution_-_ROC_-_Refinancing': 'Investment Distribution - ROC - Refinancing',
  'Investment_-_Accrue_Dividend': 'Investment - Accrue Dividend',
  'Investment_-_Interest_Paid': 'Investment - Interest Paid',
  'Investment_-_Accrue_Interest': 'Investment - Accrue Interest',
  'Investment_-_Accrue_Fee_Income': 'Investment - Accrue Fee Income',
  'Investment_-_Fee_Income_Paid': 'Investment - Fee Income Paid',
  'Investment_-_Valuation': 'Investment - Valuation',
  'Investment_-_FX_Valuation': 'Investment - FX Valuation',
  'Investment_-_Cost_Basis_Adjustment': 'Investment - Cost Basis Adjustment',
  'Investment_-_Operating_Income_Paid': 'Investment - Operating Income Paid',
  'Investment_-_PIK': 'Investment - PIK',
  'Investment_-_Write_Down': 'Investment - Write Down',
  'Investment_-_Write_Off': 'Investment - Write Off',
  Property_Sale_Distribution: 'Property Sale Distribution',
  Miscellaneous_Income: 'Miscellaneous Income',
  'Investment_-_Debt_-_Borrow': 'Investment - Debt - Borrow',
  'Investment_-_Debt_-_Pay_Interest': 'Investment - Debt - Pay Interest',
  'Investment_-_Debt_-_Accrue_Interest': 'Investment - Debt - Accrue Interest',
  'Investment_-_Debt_-_Paydown': 'Investment - Debt - Paydown',
  'Investment_-_Debt_-_Upsize': 'Investment - Debt - Upsize',
  'Investment_-_Debt_-_PIK': 'Investment - Debt - PIK',
  Management_Fee_Paid: 'Management Fee Paid',
  Management_Fee_Accrued: 'Management Fee Accrued',
  Management_Fee_Interest_Accrued: 'Management Fee Interest Accrued',
  Management_Fee_Break_Accrued: 'Management Fee Break Accrued',
  Management_Fee_Waiver: 'Management Fee Waiver',
  Management_Fee_Rebate: 'Management Fee Rebate',
  Fund_Organization_Costs: 'Fund Organization Costs',
  Fund_Accounting_Expenses: 'Fund Accounting Expenses',
  Admin_Expenses: 'Admin Expenses',
  IT_Expenses: 'IT Expenses',
  Tax_Preparatory: 'Tax Preparatory',
  Fund_Audit: 'Fund Audit',
  Fund_Bank_Fees: 'Fund Bank Fees',
  Fund_Custody_Fees: 'Fund Custody Fees',
  Fund_Due_Diligence_Costs: 'Fund Due Diligence Costs',
  Fund_Legal_Costs: 'Fund Legal Costs',
  'Fund_T&E_Expense': 'Fund T&E Expense',
  Fund_Other_Expense: 'Fund Other Expense',
  Tax_Expense: 'Tax Expense',
  Placement_Agent_Expense: 'Placement Agent Expense',
  Excess_Organization_Costs: 'Excess Organization Costs',
  Entity_Operating_Expenses: 'Entity Operating Expenses',
  'Adjustment_(General_-_Across_Transactions)': 'Adjustment (General - Across Transactions)',
  'Related_Party_Expense_#1': 'Related Party Expense #1',
  'CF_-_Investment_-_Equity': 'CF - Investment - Equity',
  'CF_-_Investment_-_Debt': 'CF - Investment - Debt',
  'CF_-_Management_Fee': 'CF - Management Fee',
  'CF_-_Working_Capital': 'CF - Working Capital',
  'CF_-_Expenses': 'CF - Expenses',
  'CF_-_Taxes': 'CF - Taxes',
  'CF_-_Interest_Expense': 'CF - Interest Expense',
  'CF_-_Investment_-_Equity_-_No_Impact_on_Fee_Basis': 'CF - Investment - Equity - No Impact on Fee Basis',
  'CF_-_Investment_-_Debt_-_No_Impact_on_Fee_Basis': 'CF - Investment - Debt - No Impact on Fee Basis',
  'CF_-_Management_Fee_-_No_Impact_on_Fee_Basis': 'CF - Management Fee - No Impact on Fee Basis',
  'CF_-_Working_Capital_-_No_Impact_on_Fee_Basis': 'CF - Working Capital - No Impact on Fee Basis',
  'CF_-_Expenses_-_No_Impact_on_Fee_Basis': 'CF - Expenses - No Impact on Fee Basis',
  'CF_-_Taxes_-_No_Impact_on_Fee_Basis': 'CF - Taxes - No Impact on Fee Basis',
  'CF_-_Interest_Expense_-_No_Impact_on_Fee_Basis': 'CF - Interest Expense - No Impact on Fee Basis',
  'Gross_Investment_Gain_/_Loss': 'Gross Investment Gain / Loss',
  'Realized_Gain_/_Loss': 'Realized Gain / Loss',
  'Unrealized_Gain_/_Loss': 'Unrealized Gain / Loss',
  Net_Portfolio_Interest_Income: 'Net Portfolio Interest Income',
  Partnership_Expenses: 'Partnership Expenses',
  Offering_Costs: 'Offering Costs',
  Corporate_Tax_Expenses: 'Corporate Tax Expenses',
  Realized_Corporate_Tax_Expenses: 'Realized Corporate Tax Expenses',
  Unrealized_Corporate_Tax_Expenses: 'Unrealized Corporate Tax Expenses',
  Realized_Excess_Organization_Costs: 'Realized Excess Organization Costs',
  Realized_Placement_Agent_Expenses: 'Realized Placement Agent Expenses',
  'NAV_Component_-_Other': 'NAV Component - Other',
} as const;
